import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import UserContext from '../tools/contextLib';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import axios from 'axios';
import TestConfig from '././praxisFold/praxisConfig'
import moment from 'moment';
import { connect } from 'react-redux';

class Praxis extends Component {
    static displayName = Praxis.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            returnable: this.props.reduxData.userInfo,
            browser: `${browserName}${browserVersion}`,
            ip: "",
            globalLevel: "",
            permissionFlag: true,
        }
        this.testPermission(this.props.reduxData.userInfo);
    }

    async getData() {
        const response = await axios.get('https://geolocation-db.com/json/');
        this.setState({
            ip: response.data.IPv4
        });
        //this.getUserInfo(response.data.IPv4);
        this.saveUserData();
    }

    async getUserInfo(ipData) {//This is supposed to force the function to wait until the axios get resolves without using .then(), jury's out on whether it works.
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } }).then((response) => response.json())
            .then((responseJSON) => { this.saveUserData(responseJSON) })
        //localStorage.setItem("lastFetch", moment());
    }

    saveUserData() {
        this.setState({
            returnable: this.props.reduxData.userInfo,
            loading: false
        })
        //this.recordComingHere(data);//I'm trying something new here. Instead of writing the user data to state and having these functions read that, I'm passing it directly through here as parameters.
                                    //Since this.setState is asynchronous, requiring these procedures to read from state means they'll at first be reading null values and so fail. This way, they'll work.
        this.testPermission(this.props.reduxData.userInfo);
        //this.findIfDataPresent(data.level);
    }

    //async recordComingHere(dataIn) {
    //    let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let toSend = {
    //        pagePK: "1029",
    //        department: dataIn.level,
    //        userPCID: dataIn.pcid,
    //        ip: this.state.ip,
    //        browser: this.state.browser,
    //        userID: dataIn.username
    //    }
    //    const response = await fetch('logging', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    localStorage.setItem("lastFetch", moment());
    //}

    async testPermission(dataIn) {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: dataIn.level.pk,
            pagepk: "1029"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            permissionFlag: data
        })
    }

    componentDidMount() {

    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
            return (
                <UserContext.Consumer>
                    {contextData => (
                        <div>
                            {!this.state.loading && <TestConfig userData={this.props.reduxData.userInfo} />}
                        </div>
                    )}
                </UserContext.Consumer>
            );
        }
    
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(Praxis);